<template>
  <div class="bottom-page layout-p pt-0">
    <b-card
      no-body
      class="bottom-page__card shadow-none pb-5"
    >
      <div class="bottom-page__title voloro-title mt-80">
        Enjoy a new investment experience
      </div>
      <div class="bottom-page__explanation font-weight-lighter font-20 mt-5 font-weight-lighter">
        Leverage our expertise in supporting complex assets and investment strategies–from hedge,
        hybrid funds to private equity and real estate.
      </div>
      <div class="bottom-page__work-types-wrap">
        <div class="bottom-page__list font-20 font-weight-lighter">
          <span class="font-20 font-weight-bold text-dark">We work with:</span>
          <ul>
            <li
              v-for="type in workTypes"
              :key="type"
              class="font-20"
            >
              {{ type }}
            </li>
          </ul>
        </div>
        <div class="bottom-page__image">
          <b-img
            :src="bankPeople"
            img-alt="image"
            class="w-100"
          />
        </div>
      </div>
    </b-card>
    <div class="bottom-page__get-ready-wrap mt-80 mb-5">
      <div>
        <div class="voloro-title">
          Ready to get started?
        </div>
        <div class="bottom-page__get-ready-subtitle font-20">
          Open your investment account in VBank.
        </div>
      </div>
      <btn-group
        blueviolet
        class="bottom-page__btn-group"
      />
    </div>
  </div>
</template>

<script>
  import bankPeople from '~/assets/img/bank-people.svg';
  import BtnGroup from '../BtnGroup';

  export default {
    name: 'BottomPage',
    components: {
      BtnGroup,
    },
    data() {
      return {
        bankPeople,
        workTypes : [
          'Corporations',
          'Institutional investors',
          'Hedge funds',
          'Governments',
          'Affluent individuals',
        ],
      }
    },
  }
</script>

<style lang="scss" src="./BottomPage.scss" />
